module.exports = __webpack_public_path__ + "static/media/logo_gray.6727c20e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_gray.svg
// module id = 1438
// module chunks = 0